import React ,{useEffect} from 'react';
import { useHistory } from "react-router-dom";



export default function useNavigate({granted,channelCode, moduleDefault}){
    const history = useHistory();
    const navigate =(granted,channelCode, moduleDefault)=>{
        if(channelCode){
            if(granted)  history.push(`/${moduleDefault || 'productos'}`)
        } else {
            if(granted)  history.push(`/${moduleDefault || 'productos'}`) 
        }
    }

    useEffect(()=>{
        navigate(granted,channelCode, moduleDefault);
    },[granted,channelCode, moduleDefault])

}